import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CallIcon from '@material-ui/icons/Call'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import React from 'react'

import { persianRegex } from '../../../../helpers/regex'
import { getTranslate } from '../../../../localization'
import { BookerForCart } from '../../../../types/cart'
import { useStyles } from './styles/index.styles'

type BookerDetailsProps = { booker: BookerForCart | undefined }

const BookerDetailsSummary: React.FC<BookerDetailsProps> = ({
  booker
}: BookerDetailsProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const isPersianBookerName =
    persianRegex.test(booker?.firstName || '') ||
    persianRegex.test(booker?.lastName || '')

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.sectionTitle}>
          {getTranslate('Booker Details')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.content}>
        <div className={classes.personCard}>
          <div className={classes.iconBox}>
            <div className={classes.iconText}>
              <AccountCircleIcon className={classes.profileIcon} />
              <Typography variant="h5" className={classes.blackText}>
                {getTranslate('Booker')}
              </Typography>
            </div>
          </div>
          <div className={classes.detailsBox}>
            <div className={classes.row}>
              {isMobile ? (
                <PersonOutlineIcon className={classes.formIcon} />
              ) : (
                <Typography variant="h6" className={classes.blackText}>
                  {`${getTranslate('Name')}: `} &nbsp;
                </Typography>
              )}
              <Typography
                variant="h5"
                className={classes.blackText}
                style={
                  isPersianBookerName ? { fontFamily: 'IranSans' } : undefined
                }>
                {booker?.firstName + ' ' + booker?.lastName}
              </Typography>
            </div>
            <div className={classes.row}>
              {isMobile ? (
                <MailOutlineIcon className={classes.formIcon} />
              ) : (
                <Typography variant="h6" className={classes.blackText}>
                  {`${getTranslate('Email')}: `} &nbsp;
                </Typography>
              )}
              <Typography variant="h6" className={classes.blackText}>
                {booker?.email}
              </Typography>
            </div>
            <div className={classes.row}>
              {isMobile ? (
                <CallIcon className={classes.formIcon} />
              ) : (
                <Typography variant="h6" className={classes.blackText}>
                  {`${getTranslate('Mobile')}: `} &nbsp;
                </Typography>
              )}

              <Typography variant="h6" className={classes.blackText}>
                {booker?.mobile}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default BookerDetailsSummary
